import clsx from "clsx";
import { useFormik } from "formik";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { snackActions } from "../../helpers/SnackUtilsConfigurator";
import { requestPassword } from "../../pages/auth/core/_requests";

const initialValues = {
  email: "",
};

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email("Wrong email format")
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Email is required"),
});

export function ForgotPassword() {
  const [loading, setLoading] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      setTimeout(() => {
        requestPassword(values.email)
          .then((data: any) => {
            if (data?.data?.status) {
              setNewPassword(data?.data?.data?.password ?? "");
              snackActions.success(data?.data?.message ?? "Success!");
              formik.resetForm();
            } else {
              snackActions.dismissibleError(
                data?.data?.message ?? "Something went wrong!, please try again"
              );
            }
            setLoading(false);
          })
          .catch((error: any) => {
            snackActions.error(
              error.response.data.message ??
                "Something went wrong!, please try again"
            );
            setLoading(false);
            setSubmitting(false);
            setStatus("Something went wrong!, please try again");
          });
      }, 1000);
    },
  });

  return (
    <form
      className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
      noValidate
      id="kt_login_password_reset_form"
      onSubmit={formik.handleSubmit}
    >
      <div className="text-center mb-8">
      <div className="logo-box">
          <img className="img-fluid" src="../media/app-logo/logo.png" alt="App Logo" />
        </div>
        {/* begin::Title */}
        <h1 className="mb-2 mt-15">Forgot Password ?</h1>
        {/* end::Title */}

        {/* begin::Link */}
        <div className="fs-20 m-0">
          Enter your email to reset your password.
        </div>
        {/* end::Link */}
      </div>

      {/* begin::Form group */}
      <div className="fv-row mb-8">
        {/* <label className="form-label fw-bolder text-gray-900 fs-6">Email</label> */}
        <input
          type="email"
          placeholder="Enter your email"
          autoComplete="off"
          {...formik.getFieldProps("email")}
          className={clsx(
            "form-control py-5",
            { "is-invalid": formik.touched.email && formik.errors.email },
            {
              "is-valid": formik.touched.email && !formik.errors.email,
            }
          )}
        />
        {formik.touched.email && formik.errors.email && (
          <div className="fv-plugins-message-container">
            <span role="alert">{formik.errors.email}</span>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
          
        <button
          type="submit"
          id="kt_password_reset_submit"
          className="btn btn-primary w-100 py-5 mb-4"
          disabled={loading}
        >
          {!loading && <span className="indicator-label">Submit</span>}
          {loading && (
            <span className="indicator-progress" style={{ display: "block" }}>
              Please wait...
              <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
            </span>
          )}
        </button>
      
       <div className="d-inline-flex justify-content-center text-center align-items-center w-100">
        <p className="m-0" onClick={() => navigate("/auth/login")}>
            Back to <u className="cursor-pointer fw-bold text-primary">Login</u>
        </p>
      </div>
      
      {/* end::Form group */}
    </form>
  );
}
